/** Forma de imagens mock alinhada a docs/contracts/api/admin/imoveis/admin-property-media.md (IMO-0021). */

import type { MockImageRow } from '@app/mock-api/mock-api-shared-models';

/** PNG 1×1 transparente (data URL curta); mesmo pixel que handlers admin para uploads novos. */
export const mockMediaListingDataUrl =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==';

export function createMockCloudinaryImageRow(args: { id: string; isPrimary: boolean; sortOrder: number }): MockImageRow {
  const listingUrl = mockMediaListingDataUrl;

  return {
    adminOriginalUrl: `${listingUrl}#admin-original`,
    externalId: `imoveis/dev/mock/${args.id}`,
    id: args.id,
    isPrimary: args.isPrimary,
    sortOrder: args.sortOrder,
    storageProvider: 'Cloudinary',
    url: listingUrl,
    urls: {
      detail: listingUrl,
      listing: listingUrl,
      thumbnail: listingUrl,
      zoom: listingUrl,
    },
  };
}

export function createMockLocalImageRow(args: { id: string; isPrimary: boolean; listingUrl: string; sortOrder: number }): MockImageRow {
  const listingUrl = args.listingUrl;

  return {
    adminOriginalUrl: null,
    externalId: null,
    id: args.id,
    isPrimary: args.isPrimary,
    sortOrder: args.sortOrder,
    storageProvider: 'Local',
    url: listingUrl,
    urls: {
      detail: listingUrl,
      listing: listingUrl,
      thumbnail: listingUrl,
      zoom: listingUrl,
    },
  };
}
